import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const messages = {    
    'en': {
        home: "Home",
        members: "Members",
        "1y": "1st year",
        "2y": "2nd year",
        "3y": "3rd year",
        "4y": "4th year",
        "grad": "Graduate Students",
        results: "Results",
        schedule: "Schedule",
        contactUs: "Contact Us",
        homeMsg: "We are UEC's Swimming Team",
        homeDesc: "This is UECST's home page. You will find here competition results, event ..etc. To contact us, please click here and send us an email.",
        updates: "Latest Updates",
        ourMembers: "Our Members",
        nameFull: "Full Name",
        role: "Role",
        belonging: "University/Depart.",
        schoolOrigin: "School of Origin",
        goal: "goal",
        mLifetimeRecords: "Male Lifetime Records (PDF)",
        fLifetimeRecords: "Female Lifetime Records (PDF)",
        name: "Name",
        competition: "Competition",
        place: "Place",
        date: "Date",
        style: "Style",
        record: "Record",
        rank: "Ranking",
        remark: "Remark",
        search: "Search",
        trainingSchedule: "Training Schedule",
        trainingScheduleDesc: "During season, we train using the university's swimming pool. We prepare menus according to the level of swimmers (until C). During the training, swimmers would point one anothers's way of swimming to learn and improve, so even people with low experience could get better quickly. Outside the season, we have morning and evening trainings in a schedule that suits everyone. The presenece of all swimmers is, in principle, required in non swimming training sessions.",
        month: "Month",
        day: "Day",
        period: "Period",
        content: "Content",
        eventSchedule: "Event Schedule",
        eventScheduleDesc_1: "There are various events/competitions, most importantly:",
        esli_1: "April: Freshmen welcome party",
        esli_2: "May: Pool cleaning",
        esli_3: "June: East Japan Science Stream Universities Competition, Eastern Area National Universities Competition..",
        esli_4: "August: Kanto Students Competition, National Convention of National Universities, OB Race, 4 Universities Tournament",
        esli_5: "September: Choufu Civilians' Tournament",
        esli_6: "December: Kanto Students Winter Cup, Official Record Competition",
        esli_7: "February: 4 Universities Training Camp",
        esli_8: "March: Kanto Students Winter Season Official Record Competition, Farewell Party",
        eventScheduleDesc_2: "The University of Electro-Communications has connection with Tokyo University of Foreign Studies, Tokyo University of Marine Science and Technology, Tokyo University of Agriculture and Technology. Each year an exchange race is held in August and a training camp around February. Thanks to these kind of events, it's possible to build deep connections with people from different universities.",
        email: "Email",
        message: "Message",
        sendMsg: "Send Message",
        info: "Info",
        links: "Links",
        university: "University of Electro-Communications",
        address: "Address: 〒182-8585 Tokyo, Chofu, Chofugaoka 1-5-1",
        emailAddress: "Email: uecst.swimmers@gmail.com",
        tufs: "Tokyo University of Foreign Studies",
        noukou: "Tokyo University of Marine Science and Technology",
        kaiyou: "Tokyo University of Agriculture and Technology",
        mon: "Mon",
        tue: "Tue",
        thu: "Thu",
        fri: "Fri",
        swimming: "swimming",
        swimmingMorning: "swimming (morning)",
        workout: "workout",
        swimmingEvening: "swimming (evening)",
        uecPool: "uecPool",
        uecGymOrPool: "UEC Gym or poolside",
        choufuGymPool: "Choufu Gym Pool"

    },    
    'jp': {        
        home: "ホーム",
        members: "部員",
        "1y": "1年",
        "2y": "2年",
        "3y": "3年",
        "4y": "4年",
        "grad": "院生",
        results: "試合結果",
        schedule: "日程",
        contactUs: "お問い合わせ",
        homeMsg: "電気通信大学水泳部です",
        homeDesc: "これは、電気通信大学水泳部のホームページです。試合結果やイベントの情報を記載しています。ご連絡はこちらのボタンをクリックしてください。",
        updates: "最新情報",
        ourMembers: "部員紹介",
        nameFull: "名前",
        role: "役職",
        belonging: "所属",
        schoolOrigin: "出身校",
        goal: "目標",
        mLifetimeRecords: "男子個人歴代記録 (PDF)",
        fLifetimeRecords: "女子個人歴代記録 (PDF)",
        name: "名前",
        competition: "大会",
        place: "場所",
        date: "日付",
        style: "種目",
        record: "タイム",
        rank: "順位",
        remark: "備考",
        search: "検索",
        trainingSchedule: "練習日程",
        trainingScheduleDesc: "シーズン中は学内のプールで練習を行っています。選手のレベルに合わせてS~Cまでのメニューを用意しています。 練習中は選手同士で指摘しあい、技術の向上にも力を入れているため水泳経験が浅い人でも問題ありません。 シーズン以外は、朝練と夕練を実施し選手それぞれの都合に合わせた練習日程を組むことができます。陸上トレーニングは 基本選手全員が参加することになっています。",
        month: "月",
        day: "曜日",
        period: "時間帯",
        content: "内容",
        eventSchedule: "行事日程",
        eventScheduleDesc_1: "電通大水泳部には多種多様な行事があります。主な行事は以下です。",
        esli_1: "4月：新入生歓迎会",
        esli_2: "5月：プール清掃",
        esli_3: "6月：東日本理工科系大学選手権・東部地区国公立大学選手権...",
        esli_4: "8月：関東学生選手権・全国国公立大学選手権・OB戦・四校戦",
        esli_5: "9月：調布市民大会",
        esli_6: "12月：関東学生ウインターカップ・公認記録会",
        esli_7: "2月：4校合宿",
        esli_8: "3月：関東学生冬季公認記録会・追いコン",
        eventScheduleDesc_2: "電気通信大学は、東京外国語大学・東京海洋大学・東京農工大学と交流があり、毎年8月に交流戦（レクリエーション）と 2月に合宿を合同で実施しています。これらの行事や試合を通して学内外での選手との交流を深めることができます。",
        email: "メール",
        message: "メッセージ",
        sendMsg: "送信する",
        info: "連絡先",
        links: "リンク",
        university: "国立大学法人電気通信大学",
        address: "住所：〒182-8585東京都調布市調布ヶ丘1-5-1",
        emailAddress: "メール: uecst.swimmers@gmail.com",
        tufs: "東京外国語大学水泳部",
        noukou: "東京農工大学水泳部",
        kaiyou: "東京海洋大学水泳部",
        mon: "月",
        tue: "火",
        thu: "木",
        fri: "金",
        swimming: "スイム練習",
        swimmingMorning: "スイム練習（朝練習）",
        workout: "筋力トレーニング",
        swimmingEvening: "スイム練習（夕練）",
        uecPool: "電通大プール",
        uecGymOrPool: "電通大トレ室 or プールサイド",
        choufuGymPool: "調布市総合体育館プール"
    }
};

const i18n = new VueI18n({    
    locale: 'jp', // set locale    
    fallbackLocale: 'en', // set fallback locale    
    messages, // set locale messages
});

export default i18n;